import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=3e7f8570"
import script from "./dept.vue?vue&type=script&lang=js"
export * from "./dept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e7f8570')) {
      api.createRecord('3e7f8570', component.options)
    } else {
      api.reload('3e7f8570', component.options)
    }
    module.hot.accept("./dept.vue?vue&type=template&id=3e7f8570", function () {
      api.rerender('3e7f8570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/dept.vue"
export default component.exports